// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'b3f6b660553a996d414bb37022077d5b8ba43ac5';
export const BUILD_NUMBER = '201';
export const BUILD_TIMESTAMP = '2026-07-22T07:20:43.005Z';
